/* eslint-disable
    goodeggs/lodash-prefer-includes,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default ngInject(function(Supplier) {
  this.suppliers = [];
  this.loading = true;

  Supplier.getSuppliers()
    .then((suppliers) => {
      this.suppliers = suppliers;
      return (this.supplierSlugs = [
        ...Array.from(this.suppliers.map((s) => s.name)),
        ...Array.from(this.suppliers.map((s) => s.slug)),
      ]);
    })
    .finally(() => (this.loading = false));

  this.isSupplierHidden = () => false;

  const matchString = (value) =>
    this.search == null ||
    value == null ||
    this.search === '' ||
    value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;

  this.searchForNameOrSlug = (supplier) => matchString(supplier.name) || matchString(supplier.slug);

  return this;
}); // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected
